"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Wholesale Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@deliverr.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EstimationError = void 0;
/**
 *
 * @export
 * @enum {string}
 */
exports.EstimationError = {
    WEIGHT_UNDER_150_LB_TOO_LOW_FOR_FREIGHT: 'WEIGHT_UNDER_150_LB_TOO_LOW_FOR_FREIGHT',
    CANNOT_SHIP_MANY_TO_ONE_PARCEL_OVER_70LB: 'CANNOT_SHIP_MANY_TO_ONE_PARCEL_OVER_70LB',
    WEIGHT_TOO_HIGH_FOR_PARCEL: 'WEIGHT_TOO_HIGH_FOR_PARCEL',
    BAD_ZIPCODE: 'BAD_ZIPCODE',
    UNEXPECTED_ERROR: 'UNEXPECTED_ERROR',
    RESPONSE_MISSING_STATUS: 'RESPONSE_MISSING_STATUS',
    MISSING_ORIGIN_WAREHOUSE: 'MISSING_ORIGIN_WAREHOUSE',
    DIMS_MISSING: 'DIMS_MISSING',
    NO_PALLET_ESTIMATION: 'NO_PALLET_ESTIMATION',
    MISSING_PALLET_ESTIMATION: 'MISSING_PALLET_ESTIMATION',
    TOO_MANY_PALLETS_FOR_LTL: 'TOO_MANY_PALLETS_FOR_LTL',
    TOO_MANY_PALLETS_FOR_FTL_ESTIMATION: 'TOO_MANY_PALLETS_FOR_FTL_ESTIMATION',
    ILLEGAL_ADDRESS: 'ILLEGAL_ADDRESS',
    NO_RATES_RECEIVED: 'NO_RATES_RECEIVED',
    MISSING_QUOTE: 'MISSING_QUOTE',
    GOOGLE_FAILED_TO_RETREIVE_DETINATION_LAT_LAN: 'GOOGLE_FAILED_TO_RETREIVE_DETINATION_LAT_LAN',
    FAILED_TO_FETCH_ADDRESS_TIMEZONE: 'FAILED_TO_FETCH_ADDRESS_TIMEZONE',
    UNSUPPORTED_PARCEL_STRATEGY_REQUESTED: 'UNSUPPORTED_PARCEL_STRATEGY_REQUESTED'
};
//# sourceMappingURL=estimation-error.js.map